import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-notesTooltip',
  templateUrl: './notes-tooltip.component.html',
  styleUrls: ['./notes-tooltip.component.scss'],
})
export class NotesTooltipComponent implements OnInit {
  @Input() selectedCellDetails: any;
  ngOnInit(): void {
  }
}
